import React, { useEffect, useState } from "react";
// @material-ui/core components

// core components
import { Card, Grid } from "@material-ui/core";
import { CardBody, CardHeader, CardTitle, Input } from "reactstrap";
import { BASE_URL } from "../../variables/api";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import Table from "../../Components/Tables/DepartmentTable";

function DepartmentConfig(props: any) {
  const { classes } = props;
  const [isOnline, setIsOnline] = useState(false);
  const [data, setData] = useState([]);
  const [add, setAdd] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <Link
        style={{ marginTop: "2%" }}
        to="/admin-tab"
        className="btn btn-secondary mb-3"
      >
        <i className="fa fa-arrow-left" aria-hidden="true" />
      </Link>

      <form>
        <Card
          style={{
            width: "100%",
            border: "2px solid",
            borderColor: "#3278bd",
            backgroundColor: "lightgrey",
          }}
        >
          <div style={{ margin: "2%", overflowX: "auto" }}>
            <Table />
          </div>
        </Card>
      </form>
    </>
  );
}

export default DepartmentConfig;
